<template>
    <div class="card-notaFiscal-pedido-andamento">      
        <g-card
        :temCabecalho="false"
        :expansivel="false"
        >
            <div class="header-notaFiscal-pedido-andamento">
                <div class="header-titulo-voltar">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />                    
                </div>

                <div class="header-icons">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    >
                    </g-button>
                </div>
            </div>

            <div class="conteudo-card-notaFiscal-pedido-andamento">
                
            </div>
        </g-card>
    </div>
</template>

<script>
import NotaFiscalPedidoEmAndamento from './NotaFiscalPedidoEmAndamento.js'
export default NotaFiscalPedidoEmAndamento
</script>

<style scoped>
.header-icons {
  display: flex;
  justify-self: center;
  column-gap: 5px;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.topico {
  padding-bottom: 20px;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
}

.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  margin-top: 15px;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

@media(min-width:310px) {
.header-notaFiscal-pedido-andamento {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.topico  {
    display: flex;
    flex-wrap: wrap;
    column-gap: 15%;
}

.grupo {
    font-size: 18px;
}
}

@media(min-width:368px) {
.header-notaFiscal-pedido-andamento {
    grid-template-columns: 25% repeat(2, auto);
}
}

@media(min-width:600px) {
.header-notaFiscal-pedido-andamento {
    padding: 20px 0 10px;
}
}

@media(min-width:801px) {
.conteudo-card-notaFiscal-pedido-andamento {
    padding: 0 30px;
}
}

@media(min-width:1025px) {
.conteudo-card-notaFiscal-pedido-andamento {
    padding: 0 50px;
}

.grupo-dados-produto, .grupo-componentes, .grupo-observacao {
    border-bottom: none;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 10px;
    column-gap: 6%;
}

.grupo {
    font-size: 19px;
}
}

@media(min-width:1285px) {}

@media(min-width:1500px) {}
</style>